import './profile.scss';
import '../register/register.scss';
import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Storage, getUrlParameter } from 'react-jhipster';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import {
  getAuths,
  handleDeleteAuth,
  handleUpdateAuth,
  getAttribute,
  updateAttribute,
  getUserProfile,
  reset,
  handleDeleteGroup,
  handleAddSmartCA,
  getInfoMapping,
  handleGetUserInfo
} from './user.reducer';
import { getListSession } from './user.reducer';
import IdentityInfo from './identity-info/identity-info';
import ListAuth from './auth/listAuth';
import ModalDeleteGroup from './modal-delete-group';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { BORN_PLACE, NATIVE_VILLAGE, RESIDENT, ADD, AUTHORIZE_SMART_CA, SUCCESS, STATUS_TYPES, oauth2 } from 'app/config/constants';
import ModalSmartCA from 'app/modules/account/register/smart-ca/modal-smart-ca';
import { signHashSmartCA } from '../register/register.reducer';
import { AuthAddSmartCAInfo } from './auth/auth-add-smartca-info';
import moment from 'moment';
import MessageModal from 'app/shared/message/message-modal';
import { generateCaptcha } from '../password-reset/password-reset.reducer';
import FederatedInfo from 'app/modules/account/user/federated/federated-info';
import ModalLookUp from './modal-look-up';

export interface IUserProfileProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}
export interface IUserProfileState {
  userInfo: any;
  userMapping: any;
  auths: any;
  showPopupDeleteGroup: boolean;
  showPopupConfirmDelete: boolean;
  groupName: string;
  showModalWaittingSmartCA: boolean;
  messageSignHashSmartCA: string;
  displayModalSmartCaInfo: boolean;
  messageErrorAddAuthSmartCA: string;
  showMessage: boolean;
  loading: boolean;
  showLookUpModal: boolean;
  dropdownOpen: boolean;
}
var dictInfoSelect = {
  streetBirthPlace: '',
  wardBirthPlace: '',
  districtBirthPlace: '',
  stateBirthPlace: '',

  streetHomeTown: '',
  wardHomeTown: '',
  districtHomeTown: '',
  stateHomeTown: '',

  streetPermanentAddress: '',
  wardPermanentAddress: '',
  districtPermanentAddress: '',
  statePermanentAddress: '',

  stateCurrentAddress: '',
  districtCurrentAddress: '',
  wardCurrentAddress: '',
  streetCurrentAddress: ''
};

let smartCAInfo = {};
export class UserProfilePage extends React.Component<IUserProfileProps, IUserProfileState> {
  state: IUserProfileState = {
    userInfo: {},
    userMapping: {},
    auths: {},
    showPopupDeleteGroup: false,
    showPopupConfirmDelete: false,
    groupName: '',
    showModalWaittingSmartCA: false,
    messageSignHashSmartCA: '',
    displayModalSmartCaInfo: false,
    messageErrorAddAuthSmartCA: '',
    showMessage: false,
    loading: true,
    showLookUpModal: false,
    dropdownOpen: false
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.userProfile !== nextProps.userProfile) {
      const { userProfile } = nextProps;
      this.props.handleGetUserInfo(userProfile.login, 'EDIT', 'PENDING_APPROVAL');
      const { loading } = this.state;
      if (loading) {
        this.setState({ loading: false });
      }
      if (userProfile.attributes == undefined) {
        return;
      }
      /**noi sinh */
      let objBirthPlace = userProfile.attributes.filter(item => item.name == BORN_PLACE.PROVINCE);
      dictInfoSelect.stateBirthPlace = objBirthPlace.length > 0 ? objBirthPlace[0].value : '';
      let objDisBirthPlace = userProfile.attributes.filter(item => item.name == BORN_PLACE.DISTRICT);
      dictInfoSelect.districtBirthPlace = objDisBirthPlace.length > 0 ? objDisBirthPlace[0].value : '';
      let objComBirthPlace = userProfile.attributes.filter(item => item.name == BORN_PLACE.COMMUNE);
      dictInfoSelect.wardBirthPlace = objComBirthPlace.length > 0 ? objComBirthPlace[0].value : '';
      let objAddBirthPlace = userProfile.attributes.filter(item => item.name == BORN_PLACE.ADDRESS);
      dictInfoSelect.streetBirthPlace = objAddBirthPlace.length > 0 ? objAddBirthPlace[0].value : '';
      /**que quan */
      let objProHomeTown = userProfile.attributes.filter(item => item.name == NATIVE_VILLAGE.PROVINCE);
      dictInfoSelect.stateHomeTown = objProHomeTown.length > 0 ? objProHomeTown[0].value : '';
      let objDisHomeTown = userProfile.attributes.filter(item => item.name == NATIVE_VILLAGE.DISTRICT);
      dictInfoSelect.districtHomeTown = objDisHomeTown.length > 0 ? objDisHomeTown[0].value : '';
      let objComHomeTown = userProfile.attributes.filter(item => item.name == NATIVE_VILLAGE.COMMUNE);
      dictInfoSelect.wardHomeTown = objComHomeTown.length > 0 ? objComHomeTown[0].value : '';
      let objAddHomeTown = userProfile.attributes.filter(item => item.name == 'streetHomeTown');
      dictInfoSelect.streetHomeTown = objAddHomeTown.length > 0 ? objAddHomeTown[0].value : '';
      /**dia chi thuong tru */
      let objProResident = userProfile.attributes.filter(item => item.name == RESIDENT.PROVINCE);
      dictInfoSelect.statePermanentAddress = objProResident.length > 0 ? objProResident[0].value : '';
      let objDisResident = userProfile.attributes.filter(item => item.name == RESIDENT.DISTRICT);
      dictInfoSelect.districtPermanentAddress = objDisResident.length > 0 ? objDisResident[0].value : '';
      let objComResident = userProfile.attributes.filter(item => item.name == RESIDENT.COMMUNE);
      dictInfoSelect.wardPermanentAddress = objComResident.length > 0 ? objComResident[0].value : '';
      let objAddResident = userProfile.attributes.filter(item => item.name == 'streetPermanentAddress');
      dictInfoSelect.streetPermanentAddress = objAddResident.length > 0 ? objAddResident[0].value : '';
      /**dia chi hien tai */
      let objProAdd = userProfile.attributes.filter(item => item.name == ADD.PROVINCE);
      dictInfoSelect.stateCurrentAddress = objProAdd.length > 0 ? objProAdd[0].value : '';
      let objDisAdd = userProfile.attributes.filter(item => item.name == ADD.DISTRICT);
      dictInfoSelect.districtCurrentAddress = objDisAdd.length > 0 ? objDisAdd[0].value : '';
      let objWardAdd = userProfile.attributes.filter(item => item.name == ADD.COMMUNE);
      dictInfoSelect.wardCurrentAddress = objWardAdd.length > 0 ? objWardAdd[0].value : '';
      let objAdd = userProfile.attributes.filter(item => item.name == ADD.ADDRESS);
      dictInfoSelect.streetCurrentAddress = objAdd.length > 0 ? objAdd[0].value : '';
    }
    this.setState({
      showPopupConfirmDelete: false
    });

    if (nextProps.signHashSmartCAFail) {
      // time out
      this.sighHashError('Có lỗi xảy ra trong quá trình ký số, Vui lòng thử lại!');
    }
    if (this.props.responseSignSmartCA !== nextProps.responseSignSmartCA) {
      const { responseSignSmartCA } = nextProps;
      if (responseSignSmartCA.status === SUCCESS) {
        smartCAInfo = responseSignSmartCA.data;
        this.setState({
          showModalWaittingSmartCA: false,
          messageSignHashSmartCA: '',
          displayModalSmartCaInfo: true
        });
      } else if (responseSignSmartCA.status === 'SMART_CA_SIGN_ERROR') {
        this.sighHashError(responseSignSmartCA.message);
      } else {
        this.sighHashError('Có lỗi xảy ra trong quá trình ký số, Vui lòng thử lại!');
      }
    }
    if (this.props.responseAddSmartca !== nextProps.responseAddSmartca) {
      const { responseAddSmartca } = nextProps;
      if (responseAddSmartca.status === SUCCESS) {
        this.setState({
          messageErrorAddAuthSmartCA: '',
          showMessage: true,
          displayModalSmartCaInfo: false
        });
        setTimeout(() => {
          this.setState({
            showMessage: false
          });
        }, 4000);
      } else {
        if (responseAddSmartca.status === 'KEY_NOT_CORRECT') {
          this.props.generateCaptcha();
        }
        this.setState({
          messageErrorAddAuthSmartCA: responseAddSmartca.message,
          showMessage: false
        });
      }
    }
  }

  componentWillMount() {
    const id = getUrlParameter('id', this.props.location.search);
    const techID = Storage.session.get('techID');
    if (techID && id && techID != id) {
      Storage.session.remove('jhi-authenticationToken');
      window.location.reload();
    }
  }

  componentDidMount() {
    this.props.getAuths(null, null);
    this.props.getUserProfile();
    this.props.getInfoMapping();
    this.props.getListSession();
    // const code = getUrlParameter('code', this.props.location.search);
    // const codeSmartCA = Storage.session.get('codeSmartCA');
    // if (codeSmartCA !== undefined && code === codeSmartCA) {
    //   return;
    // }
    // if (code) {
    //   Storage.session.set('codeSmartCA', code);
    //   this.signHashSmartCA(code);
    // }
  }

  sighHashError = message => {
    this.setState({
      messageSignHashSmartCA: message
    });
    setTimeout(() => {
      this.setState({
        showModalWaittingSmartCA: false,
        messageSignHashSmartCA: ''
      });
    }, 4000);
  };

  signHashSmartCA = code => {
    this.setState({ showModalWaittingSmartCA: true });
    this.props.signHashSmartCA(code, this.props.config.redirectUriUserProfileSmartCA);
  };

  handleDeleteAuth = id => {
    this.props.handleDeleteAuth(id);
  };

  handleUpdateAuth = id => {
    this.props.handleUpdateAuth(id);
  };

  handleDeleteGroup = groupName => {
    if (groupName === null) {
      this.setState({
        showPopupDeleteGroup: true,
        showPopupConfirmDelete: false
      });
    } else {
      this.setState({
        showPopupDeleteGroup: false,
        showPopupConfirmDelete: true,
        groupName: groupName
      });
    }
  };

  deleteGroup = name => {
    this.props.handleDeleteGroup(name);
  };

  closePopup = () => {
    this.setState({
      showPopupDeleteGroup: false
    });
  };

  toggle = () => {
    this.setState({
      showPopupConfirmDelete: false
    });
  };

  addAuthSmartCA = () => {
    window.location.href =
      this.props.config.urlAuthCodeSmartCA +
      '?response_type=' +
      AUTHORIZE_SMART_CA.code +
      '&redirect_uri=' +
      this.props.config.redirectUriUserProfileSmartCA +
      '&client_id=' +
      this.props.config.cliendIDSmartCA +
      '&scope=' +
      AUTHORIZE_SMART_CA.scope;
  };

  addSmartCA = certInfo => {
    var dict = {};
    dict['IssuerDN'] = certInfo.issuerCN;
    dict['sub'] = certInfo.sub;
    dict['validFrom'] = moment(certInfo.notBefore, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY');
    dict['validTo'] = moment(certInfo.notAfter, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY');
    dict['serial'] = certInfo.serialNumber;
    dict['cert'] = certInfo.cert;
    dict['email'] = certInfo.email;
    dict['fullName'] = certInfo.subjectCN;
    dict['identity'] = certInfo.identity;
    dict['tax'] = certInfo.tax;
    dict['userType'] = this.props.userProfile ? this.props.userProfile.userType : '';
    dict['captcha'] = certInfo.captcha;
    this.props.handleAddSmartCA(dict);
  };

  closeModalSmartCA = () => {
    this.setState({
      messageErrorAddAuthSmartCA: '',
      displayModalSmartCaInfo: false
    });
  };

  handleClose = () => {
    if (this.state.showLookUpModal === true) {
      this.setState({
        showLookUpModal: false
      });
    }
  };

  handleLogout = (e, isLogout) => {
    e.preventDefault();
    const AUTH_TOKEN_KEY = 'jhi-authenticationToken';
    var tokenId = Storage.session.get(AUTH_TOKEN_KEY);

    Storage.session.set(AUTH_TOKEN_KEY, '');

    const logoutRedirect = (window.location.href =
      (this.props.config.urlAuth ? this.props.config.urlAuth : 'https://xacthuc.mae.gov.vn') +
      '/oidc/logout' +
      '?id_token_hint=' +
      tokenId +
      '&post_logout_redirect_uri=' +
      (this.props.config.urlEid ? this.props.config.urlEid : oauth2.URL_CALLBACK));
  };

  searchAuth = name => {
    this.props.getAuths(null, name);
  };

  render() {
    const { userProfile } = this.props;
    return (
      <div>
        <div className="user-profile-header">
          <div className="user-info">
            <span className="user-name">{userProfile.fullname ? userProfile.fullname : ''}</span>
            <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}>
              <DropdownToggle caret />
              <DropdownMenu>
                <DropdownItem onClick={() => this.setState({ showLookUpModal: true })}>Tra cứu thông tin</DropdownItem>
                <DropdownItem onClick={this.handleLogout}>Đăng xuất</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        {window.location === window.parent.location ? null : window['styleUserProfile']()}
        <input type="hidden" id="userprofile" value="UserProfile" />
        <AuthAddSmartCAInfo
          modalShow={this.state.displayModalSmartCaInfo}
          smartcaInfo={smartCAInfo}
          addAuthSmartCA={this.addSmartCA}
          errMessage={this.state.messageErrorAddAuthSmartCA}
          handleCloseModal={this.closeModalSmartCA}
          generateCaptcha={this.props.generateCaptcha}
          captcha={this.props.responseCap.message}
        />

        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã thêm thành công.'} />
        {/*<ModalSmartCA showModal={this.state.showModalWaittingSmartCA} message={this.state.messageSignHashSmartCA} />*/}
        <Modal isOpen={this.state.showPopupConfirmDelete} backdrop="static" centered={window.location === window.parent.location}>
          <ModalHeader>
            <h3 className="font-weight-bold">Thông Báo</h3>
          </ModalHeader>
          <ModalBody className="padding-modal-body">
            <Row style={{ padding: '20px' }}>
              <h5>
                <span>Bạn có chắc chắn muốn xóa?</span>
              </h5>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register" onClick={() => this.deleteGroup(this.state.groupName)}>
              Ok
            </Button>{' '}
            <Button className="btn-register-white" onClick={() => this.toggle()}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <ModalDeleteGroup showModalConfirm={this.state.showPopupDeleteGroup} invokeAgree={this.closePopup} />
        <ModalLookUp showLookUpModal={this.state.showLookUpModal} handleClose={this.handleClose} />
        {/* Thong tin dinh danh */}
        <IdentityInfo dictInfoAddress={dictInfoSelect} />

        {/* Cac phuong thuc xac thuc */}
        <ListAuth
          listAuth={this.props.auths}
          deleteAuth={this.handleDeleteAuth}
          handleActive={this.handleUpdateAuth}
          deleteGroup={this.handleDeleteGroup}
          config={this.props.config}
          search={this.searchAuth}
          addAuthSmartCA={this.addAuthSmartCA} // userProfile={this.props.userProfile ? this.props.userProfile : null}
        />
        {/* Thong tin lien ket */}
        {this.props.infoMapping && this.props.infoMapping.createdDate ? <FederatedInfo infoMapping={this.props.infoMapping} /> : null}

        {/* quan ly section */}
        {/* <ListSessionInfo listSessionInfo={this.props.listSession} /> */}
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  auths: storeState.userInfo.auths,
  userInfo: storeState.authentication.account,
  listAttr: storeState.userInfo.listAttr,
  listSession: storeState.userInfo.listSection,
  userProfile: storeState.userInfo.userProfile,
  config: storeState.applicationProfile.config,
  responseSignSmartCA: storeState.register.responseSignHashSmartCA,
  signHashSmartCAFail: storeState.register.signHashSmartCAFails,
  responseAddSmartca: storeState.userInfo.responseAddAuthSmartCA,
  responseCap: storeState.passwordReset.responseCaptcha,
  infoMapping: storeState.userInfo.infoMapping
});

const mapDispatchToProps = {
  getAuths,
  handleDeleteAuth,
  handleUpdateAuth,
  getAttribute,
  updateAttribute,
  getUserProfile,
  reset,
  getListSession,
  handleDeleteGroup,
  signHashSmartCA,
  handleAddSmartCA,
  generateCaptcha,
  getInfoMapping,
  handleGetUserInfo
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfilePage);
